import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import MyCkeditor from '@/components/editor/MyCkeditor';
import { RecordFormShell } from '@/components/shared/RecordFormShell';
import Fieldset from '@/components/ui/daisy/fieldset';
import { ImageFolderEnum } from '@/models/CkEditor';

export type ScheduledLessonHomeworkFormFields = {
  content: string;
};

type ScheduledLessonHomeworkFormProps = {
  defaultContent?: string;
  onSubmit: (content: string) => void | Promise<unknown>;
  onCancel: () => void;
  isLoading?: boolean;
};

export default function ScheduledLessonHomeworkForm({
  defaultContent,
  onSubmit,
  onCancel,
  isLoading,
}: ScheduledLessonHomeworkFormProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'scheduledLessonReportModal',
  });

  const {
    control,
    handleSubmit,
    formState: { isDirty },
  } = useForm<ScheduledLessonHomeworkFormFields>({
    defaultValues: { content: defaultContent ?? '' },
  });

  return (
    <RecordFormShell
      hasChanges={isDirty}
      isSaving={isLoading}
      onSubmit={handleSubmit(({ content }) => onSubmit(content))}
      onCancel={onCancel}
    >
      <Controller
        name="content"
        control={control}
        rules={{ required: t('emptyContent') }}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <Fieldset labelAlt={error?.message}>
            <MyCkeditor
              testId="homeworkContent"
              content={value}
              folder={ImageFolderEnum.HOMEWORK}
              handleContentChange={onChange}
              placeholder={t('homeworkPlaceholder')}
            />
          </Fieldset>
        )}
      />

      <RecordFormShell.Actions className="justify-end" />
    </RecordFormShell>
  );
}
